export interface MagnetResource {
  id: string;
  title: string;
  category: string;
  size: string;
  date: string;
  seeds: number;
  leeches: number;
  magnetHash: string;
  tags: string[];
}

export const hotResources: MagnetResource[] = [
  {
    id: 'res-001',
    title: '流浪地球3：终章之战 2026 4K HDR 杜比全景声 国语中字',
    category: 'movie',
    size: '28.6 GB',
    date: '2026-08-06',
    seeds: 12583,
    leeches: 3421,
    magnetHash: 'A1B2C3D4E5F6A7B8C9D0E1F2A3B4C5D6E7F8A9B0',
    tags: ['4K', 'HDR', '杜比全景声', '国语'],
  },
  {
    id: 'res-002',
    title: '周杰伦 2026 世界巡回演唱会 台北站 完整版 无损FLAC',
    category: 'music',
    size: '4.2 GB',
    date: '2026-08-05',
    seeds: 8921,
    leeches: 2156,
    magnetHash: 'B2C3D4E5F6A7B8C9D0E1F2A3B4C5D6E7F8A9B0A1',
    tags: ['无损', 'FLAC', '演唱会', '华语'],
  },
  {
    id: 'res-003',
    title: 'Photoshop 2026 v27.0 完美破解版 中文绿色便携版 Win/Mac',
    category: 'software',
    size: '3.8 GB',
    date: '2026-08-06',
    seeds: 6789,
    leeches: 1890,
    magnetHash: 'C3D4E5F6A7B8C9D0E1F2A3B4C5D6E7F8A9B0A1B2',
    tags: ['破解', '中文', '便携版', '设计'],
  },
  {
    id: 'res-004',
    title: '黑神话：悟空 完全版 含所有DLC 最新更新补丁 中文',
    category: 'game',
    size: '86.5 GB',
    date: '2026-08-04',
    seeds: 15234,
    leeches: 5678,
    magnetHash: 'D4E5F6A7B8C9D0E1F2A3B4C5D6E7F8A9B0A1B2C3',
    tags: ['动作', '国产', '3A', '中文'],
  },
  {
    id: 'res-005',
    title: '三体 电视剧 第二季 全12集 4K杜比视界 国语中字',
    category: 'tv',
    size: '52.3 GB',
    date: '2026-08-03',
    seeds: 9876,
    leeches: 4321,
    magnetHash: 'E5F6A7B8C9D0E1F2A3B4C5D6E7F8A9B0A1B2C3D4',
    tags: ['4K', '杜比视界', '国产剧', '科幻'],
  },
  {
    id: 'res-006',
    title: 'Python编程：从入门到实践 第4版 PDF+EPUB+配套源码',
    category: 'document',
    size: '156 MB',
    date: '2026-08-05',
    seeds: 4521,
    leeches: 987,
    magnetHash: 'F6A7B8C9D0E1F2A3B4C5D6E7F8A9B0A1B2C3D4E5',
    tags: ['编程', 'Python', '电子书', '教程'],
  },
  {
    id: 'res-007',
    title: 'Running Man 2026 最新合集 E750-E780 韩语中字 1080P',
    category: 'variety',
    size: '45.8 GB',
    date: '2026-08-02',
    seeds: 5678,
    leeches: 2345,
    magnetHash: 'A7B8C9D0E1F2A3B4C5D6E7F8A9B0A1B2C3D4E5F6',
    tags: ['综艺', '韩综', '1080P', '中字'],
  },
  {
    id: 'res-008',
    title: '鬼灭之刃 无限城篇 剧场版 2026 日语中字 4K HDR',
    category: 'anime',
    size: '18.2 GB',
    date: '2026-08-06',
    seeds: 11234,
    leeches: 3456,
    magnetHash: 'B8C9D0E1F2A3B4C5D6E7F8A9B0A1B2C3D4E5F6A7',
    tags: ['4K', 'HDR', '剧场版', '日语'],
  },
];

export const categoryResources: Record<string, MagnetResource[]> = {
  movie: [
    { id: 'mv-001', title: '流浪地球3：终章之战 2026 4K HDR 杜比全景声 国语中字', category: 'movie', size: '28.6 GB', date: '2026-08-06', seeds: 12583, leeches: 3421, magnetHash: 'MV001HASH', tags: ['4K', 'HDR', '科幻'] },
    { id: 'mv-002', title: '封神第二部：战火西岐 2025 蓝光原盘 国语中字', category: 'movie', size: '42.1 GB', date: '2026-07-28', seeds: 8934, leeches: 2104, magnetHash: 'MV002HASH', tags: ['蓝光', '神话', '国产'] },
    { id: 'mv-003', title: '奥本海默 2023 IMAX版 4K蓝光 REMUX 英语中字', category: 'movie', size: '92.7 GB', date: '2026-07-15', seeds: 15678, leeches: 4321, magnetHash: 'MV003HASH', tags: ['IMAX', '4K', '传记'] },
    { id: 'mv-004', title: '速度与激情12 2026 抢先版 中英双字 1080P', category: 'movie', size: '3.2 GB', date: '2026-08-05', seeds: 6543, leeches: 8765, magnetHash: 'MV004HASH', tags: ['动作', '抢先', '1080P'] },
    { id: 'mv-005', title: '哪吒之魔童闹海 2025 4K HDR 国粤双语', category: 'movie', size: '22.4 GB', date: '2026-06-20', seeds: 10234, leeches: 2345, magnetHash: 'MV005HASH', tags: ['动画', '4K', '国产'] },
    { id: 'mv-006', title: '沙丘3：预言 2026 4K IMAX 英语全景声 中英双字', category: 'movie', size: '55.8 GB', date: '2026-08-01', seeds: 9876, leeches: 3210, magnetHash: 'MV006HASH', tags: ['科幻', 'IMAX', '4K'] },
    { id: 'mv-007', title: '孤注一掷2 2026 高清1080P 国语中字', category: 'movie', size: '2.8 GB', date: '2026-08-04', seeds: 7654, leeches: 5432, magnetHash: 'MV007HASH', tags: ['犯罪', '国产', '1080P'] },
    { id: 'mv-008', title: '阿凡达4：新世界 2026 3D版 蓝光原盘 英语中字', category: 'movie', size: '78.3 GB', date: '2026-07-30', seeds: 13456, leeches: 4567, magnetHash: 'MV008HASH', tags: ['3D', '科幻', '蓝光'] },
  ],
  tv: [
    { id: 'tv-001', title: '三体 电视剧 第二季 全12集 4K杜比视界 国语中字', category: 'tv', size: '52.3 GB', date: '2026-08-03', seeds: 9876, leeches: 4321, magnetHash: 'TV001HASH', tags: ['4K', '科幻', '国产'] },
    { id: 'tv-002', title: '庆余年 第三季 全24集 4K HDR 国语中字', category: 'tv', size: '68.9 GB', date: '2026-07-25', seeds: 14567, leeches: 3245, magnetHash: 'TV002HASH', tags: ['4K', '古装', '国产'] },
    { id: 'tv-003', title: '怪奇物语 第五季 全8集 4K HDR 英语中字', category: 'tv', size: '45.2 GB', date: '2026-07-10', seeds: 11234, leeches: 2890, magnetHash: 'TV003HASH', tags: ['4K', '科幻', '美剧'] },
    { id: 'tv-004', title: '狂飙2：风暴再起 全30集 1080P 国语中字', category: 'tv', size: '35.6 GB', date: '2026-08-01', seeds: 8765, leeches: 6543, magnetHash: 'TV004HASH', tags: ['犯罪', '国产', '1080P'] },
    { id: 'tv-005', title: '龙之家族 第三季 全10集 4K 杜比视界 英语中字', category: 'tv', size: '58.4 GB', date: '2026-07-20', seeds: 10234, leeches: 3456, magnetHash: 'TV005HASH', tags: ['4K', '奇幻', '美剧'] },
    { id: 'tv-006', title: '大奉打更人 第二季 全20集 1080P 国语中字', category: 'tv', size: '28.7 GB', date: '2026-08-05', seeds: 7654, leeches: 2109, magnetHash: 'TV006HASH', tags: ['古装', '国产', '1080P'] },
  ],
  music: [
    { id: 'ms-001', title: '周杰伦 2026 世界巡回演唱会 台北站 完整版 无损FLAC', category: 'music', size: '4.2 GB', date: '2026-08-05', seeds: 8921, leeches: 2156, magnetHash: 'MS001HASH', tags: ['无损', '演唱会', '华语'] },
    { id: 'ms-002', title: 'Taylor Swift - The Eras Tour 2026 终极收藏版 FLAC 48kHz', category: 'music', size: '6.8 GB', date: '2026-07-30', seeds: 10234, leeches: 3456, magnetHash: 'MS002HASH', tags: ['无损', '欧美', '演唱会'] },
    { id: 'ms-003', title: '华语经典300首 精选合集 192kHz 母带级音质 FLAC', category: 'music', size: '38.5 GB', date: '2026-07-15', seeds: 15678, leeches: 4321, magnetHash: 'MS003HASH', tags: ['合集', '华语', '母带'] },
    { id: 'ms-004', title: '久石让 宫崎骏动画音乐全集 2026重制版 DSD128', category: 'music', size: '25.6 GB', date: '2026-07-08', seeds: 9876, leeches: 2345, magnetHash: 'MS004HASH', tags: ['DSD', '原声', '动画'] },
    { id: 'ms-005', title: '2026格莱美年度最佳专辑合集 FLAC 24bit 96kHz', category: 'music', size: '12.4 GB', date: '2026-08-02', seeds: 7654, leeches: 1876, magnetHash: 'MS005HASH', tags: ['无损', '欧美', '格莱美'] },
  ],
  software: [
    { id: 'sw-001', title: 'Photoshop 2026 v27.0 完美破解版 中文绿色便携版 Win/Mac', category: 'software', size: '3.8 GB', date: '2026-08-06', seeds: 6789, leeches: 1890, magnetHash: 'SW001HASH', tags: ['设计', '破解', '中文'] },
    { id: 'sw-002', title: 'Windows 12 Pro 24H2 官方原版镜像 永久激活', category: 'software', size: '6.5 GB', date: '2026-07-28', seeds: 12345, leeches: 5678, magnetHash: 'SW002HASH', tags: ['系统', '原版', '激活'] },
    { id: 'sw-003', title: 'Office 2026 专业增强版 一键安装 永久激活 Win/Mac', category: 'software', size: '4.2 GB', date: '2026-07-20', seeds: 9876, leeches: 2345, magnetHash: 'SW003HASH', tags: ['办公', '激活', '中文'] },
    { id: 'sw-004', title: 'AutoCAD 2026 中文破解版 含全套插件 Win/Mac', category: 'software', size: '5.8 GB', date: '2026-08-01', seeds: 5678, leeches: 1234, magnetHash: 'SW004HASH', tags: ['设计', 'CAD', '破解'] },
    { id: 'sw-005', title: 'Adobe全家桶 2026 大师版 完整破解 Win/Mac', category: 'software', size: '32.6 GB', date: '2026-07-12', seeds: 15678, leeches: 4567, magnetHash: 'SW005HASH', tags: ['Adobe', '全家桶', '设计'] },
  ],
  document: [
    { id: 'dc-001', title: 'Python编程：从入门到实践 第4版 PDF+EPUB+配套源码', category: 'document', size: '156 MB', date: '2026-08-05', seeds: 4521, leeches: 987, magnetHash: 'DC001HASH', tags: ['编程', '教程', 'Python'] },
    { id: 'dc-002', title: '2026公务员考试 全套备考资料 行测+申论+面试', category: 'document', size: '8.6 GB', date: '2026-07-25', seeds: 8765, leeches: 2345, magnetHash: 'DC002HASH', tags: ['公考', '资料', '考试'] },
    { id: 'dc-003', title: '三体全集+球状闪电+超新星纪元 刘慈欣 精校版 EPUB', category: 'document', size: '24 MB', date: '2026-07-18', seeds: 6543, leeches: 1234, magnetHash: 'DC003HASH', tags: ['科幻', '小说', 'EPUB'] },
    { id: 'dc-004', title: '哈佛大学公开课 全套视频+讲义 中英字幕', category: 'document', size: '45.2 GB', date: '2026-06-30', seeds: 10234, leeches: 4567, magnetHash: 'DC004HASH', tags: ['公开课', '哈佛', '教育'] },
    { id: 'dc-005', title: '2026法考全套资料 精讲+真题+背诵版 瑞达/厚大/众合', category: 'document', size: '32.8 GB', date: '2026-07-22', seeds: 5678, leeches: 1098, magnetHash: 'DC005HASH', tags: ['法考', '资料', '法律'] },
  ],
  game: [
    { id: 'gm-001', title: '黑神话：悟空 完全版 含所有DLC 最新更新补丁 中文', category: 'game', size: '86.5 GB', date: '2026-08-04', seeds: 15234, leeches: 5678, magnetHash: 'GM001HASH', tags: ['动作', '国产', '3A'] },
    { id: 'gm-002', title: 'GTA6 完整破解版 离线模式 中文汉化', category: 'game', size: '158.2 GB', date: '2026-07-30', seeds: 23456, leeches: 8765, magnetHash: 'GM002HASH', tags: ['开放世界', '3A', '中文'] },
    { id: 'gm-003', title: '原神 7.0版本 全角色解锁 单机离线版', category: 'game', size: '95.6 GB', date: '2026-08-01', seeds: 12345, leeches: 4321, magnetHash: 'GM003HASH', tags: ['RPG', '二次元', '开放世界'] },
    { id: 'gm-004', title: '战神：诸神黄昏 PC版 完整中文版 全DLC', category: 'game', size: '175.3 GB', date: '2026-07-15', seeds: 18765, leeches: 6543, magnetHash: 'GM004HASH', tags: ['动作', '3A', '神话'] },
    { id: 'gm-005', title: '星露谷物语 1.7 终极版 全MOD整合 中文', category: 'game', size: '4.2 GB', date: '2026-08-02', seeds: 8765, leeches: 2109, magnetHash: 'GM005HASH', tags: ['模拟', '休闲', 'MOD'] },
  ],
  variety: [
    { id: 'vr-001', title: 'Running Man 2026 最新合集 E750-E780 韩语中字 1080P', category: 'variety', size: '45.8 GB', date: '2026-08-02', seeds: 5678, leeches: 2345, magnetHash: 'VR001HASH', tags: ['韩综', '1080P', '中字'] },
    { id: 'vr-002', title: '乘风破浪的姐姐 第六季 全12期 4K 国语', category: 'variety', size: '68.4 GB', date: '2026-07-28', seeds: 8765, leeches: 3456, magnetHash: 'VR002HASH', tags: ['国产', '4K', '音乐'] },
    { id: 'vr-003', title: '脱口秀大会 第七季 全10期 1080P 国语', category: 'variety', size: '25.6 GB', date: '2026-08-05', seeds: 6543, leeches: 1876, magnetHash: 'VR003HASH', tags: ['国产', '喜剧', '1080P'] },
    { id: 'vr-004', title: 'BTS 防弹少年团 2026世界巡演纪录片 4K 韩语中字', category: 'variety', size: '32.8 GB', date: '2026-07-20', seeds: 10234, leeches: 3456, magnetHash: 'VR004HASH', tags: ['韩综', '4K', '纪录片'] },
  ],
  anime: [
    { id: 'an-001', title: '鬼灭之刃 无限城篇 剧场版 2026 日语中字 4K HDR', category: 'anime', size: '18.2 GB', date: '2026-08-06', seeds: 11234, leeches: 3456, magnetHash: 'AN001HASH', tags: ['4K', '剧场版', '日语'] },
    { id: 'an-002', title: '海贼王 最终篇章 第1200-1250集 1080P 日语中字', category: 'anime', size: '42.6 GB', date: '2026-07-30', seeds: 15678, leeches: 4567, magnetHash: 'AN002HASH', tags: ['长篇', '热血', '1080P'] },
    { id: 'an-003', title: '进击的巨人 最终季 完全版 4K REMUX 日语中字', category: 'anime', size: '68.4 GB', date: '2026-07-15', seeds: 13456, leeches: 3245, magnetHash: 'AN003HASH', tags: ['4K', '动画', '日语'] },
    { id: 'an-004', title: '间谍过家家 第三季 全12集 1080P 简繁日内封', category: 'anime', size: '15.6 GB', date: '2026-08-03', seeds: 9876, leeches: 2345, magnetHash: 'AN004HASH', tags: ['喜剧', '1080P', '日常'] },
    { id: 'an-005', title: '时光代理人 第三季 全12集 4K 国语中字', category: 'anime', size: '22.4 GB', date: '2026-07-25', seeds: 7654, leeches: 1876, magnetHash: 'AN005HASH', tags: ['国漫', '4K', '悬疑'] },
  ],
};